import React, { useEffect, useRef, useState } from "react";
import fieldPropTypes from "./field-prop-types";

const SegmentControlField = ({ field, appData }) => {
  const { name, options } = field;
  const { handleChange } = appData;
  const initialValue =
    appData.values[name] || options.find(({ selected }) => selected).value;
  const initialActiveIndex = options.findIndex(
    ({ value }) => value === initialValue
  );
  const [activeIndex, setActiveIndex] = useState(initialActiveIndex);
  const itemsRef = useRef([]);

  const handleButtonClick = (value, index) => {
    if (activeIndex === index) {
      return;
    }
    setActiveIndex(index);
    handleChange({ [name]: value });
  };

  const [isInitialMount, setIsInitialMount] = useState(true);

  useEffect(() => {
    if (isInitialMount) {
      setIsInitialMount(false);
    } else {
      itemsRef.current[activeIndex].blur();
      setTimeout(() => itemsRef.current[activeIndex].focus(), 0);
    }
  }, [activeIndex]);

  return (
    <div className='segment-control-field-wrapper' role='tablist'>
      {options.map(({ value, text, accessibility }, index) => (
        <button
          className={`segment-control-button-web-sdk${
            index === activeIndex ? " active" : ""
          }`}
          type='button'
          name={name}
          key={text}
          onClick={() => handleButtonClick(value, index)}
          role='tab'
          aria-selected={index === activeIndex ? "true" : "false"}
          ref={el => (itemsRef.current[index] = el)}
          aria-label={accessibility ? accessibility.aria_label : null}
        >
          {text.toLowerCase()}
        </button>
      ))}
    </div>
  );
};

SegmentControlField.propTypes = fieldPropTypes;

export default SegmentControlField;
